import axios from 'axios';
import Swal from "sweetalert2";
import config from 'src/config'; // Import the config file
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Service {


  constructor() {

    var USER_TOKEN = localStorage.getItem('access_key');
    const AuthStr = 'Bearer '.concat(USER_TOKEN);
    // console.log(AuthStr);
    let service = axios.create({
      // headers: {
      //   'Authorization': AuthStr
      // },

      
    });
    service.interceptors.response.use(this.handleSuccess, this.handleError);
    this.service = service;
  }
  appUrl() {
    var entity = localStorage.getItem('entity');
    var url = config[process.env.REACT_APP_ENVIRONMENT].apiUrl;
    return url;
  }
  makeURL(words) {
    var n = words.split("/");
    var module = n[n.length - 3];
    var tabname = n[n.length - 2];
    return "" + module + "/" + tabname;
  }
  makeFilterURL(words) {
    var n = words.split("/");
    var module = n[n.length - 2];
    var tabname = n[n.length - 1];
    return "" + module + "/" + tabname;
  }
  dateTimeString() {
    var today = new Date();
    var date = today.getFullYear() + '' + (today.getMonth() + 1) + '' + today.getDate();
    var time = today.getHours() + "" + today.getMinutes() + "" + today.getSeconds();
    var CurrentDateTime = date + '_' + time;
    return CurrentDateTime;
  }
  baseUrl() {
    var url = config[process.env.REACT_APP_ENVIRONMENT].apiUrl;
    return url;
  }
  ServicesUrl() {
    var entity = localStorage.getItem('entity');
    var value = 0;
    if (entity == '12345') {
      value = 1;
    } else {
      value = entity
    }
    var url = config[process.env.REACT_APP_ENVIRONMENT].apiUrl;
    return url;
  }

  handleSuccess(response) {

    return response;
  }

  handleError = (error) => {
    console.log(error);
    switch (error.response.status) {
      case 401:
       

        break;
      case 404:
      

        break;
      case 403:
        Swal.fire({
          icon: 'error',
          title: 'Request failed',
          text: error.response.data.errors[0]['message'],
          showClass: {
            popup: 'animate__animated animate__fadeInDown'
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp'
          }
        });
        break;
      case 400:

        Swal.fire({
          icon: 'error',
          title: 'Request failed',
          text: error.response.data.errors[0]['message'],
          footer: '<p></p>'
        });
        break;

      case 500:

        Swal.fire({
          icon: 'error',
          title: 'Request failed',
          text: error.response.data.errors[0]['message'],
          footer: '<p></p>'
        });
        break;
      default:
        // this.redirectTo(document, '/500')
        break;
    }
    return Promise.reject(error)
  }

  redirectTo = (document, path) => {
    document.location = path
  }

  get(path) {
    return this.service.get(this.baseUrl() + '' + path)
      .then(response => response.data)
      .catch(error => {
        console.error("Error fetching data for the child dropdown:", error);
        throw error; // Rethrow the error to be handled in the calling function
      });
  }


  get(path, callback) {

    return this.service.get(this.baseUrl() + '' + path).then(
      (response) => callback(response.status, response.data)
    );
  }

  apiGet(path, callback) {
    var response = this.service.get(this.baseUrl() + '' + path);
    return response;
  }

  put(path, payload, callback) {
    return this.service.request({
      method: 'PUT',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload
    }).then((response) => callback(response.status, response.data));
  }

  post(path, payload, callback) {

    return this.service.request({
      method: 'POST',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload,

    }).then((response) => callback(response.status, response.data));
  }

  delete(path, payload, callback) {

    return this.service.request({
      method: 'DELETE',
      url: this.baseUrl() + '' + path,
      responseType: 'json',
      data: payload,

    }).then((response) => callback(response.status, response.data));
  }


  groupByKey(array, key) {
    return array
      .reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
      }, {})
  }
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  switchColors() {
    var r, g, b, rg, gb, rb;
    var range = 255; // controls the range of r,g,b you would like
    var sep = range / 4; // controls the minimum separation for saturation
    do {
      r = Math.floor(Math.random() * range);
      g = Math.floor(Math.random() * range);
      b = Math.floor(Math.random() * range);

      rg = Math.abs(r - g);
      gb = Math.abs(g - b);
      rb = Math.abs(r - b);
    } while (rg < sep || gb < sep || rb < sep);

    //convert the rgb to hex

    function rgbtohex(rgb) {
      var first, second; // makes the two hex code for each rgb value

      first = Math.floor(rgb / 16); //get first unit of hex
      second = rgb % 16; //get second unit of hex
      // convert to string with hex base 16
      first = first.toString(16);
      second = second.toString(16);
      //concatenate the two units of the hex
      var rgbtohex = first + second;
      //return the two unit hex code for the r,g,b value
      return rgbtohex;
    }

    //convert the r,g,b numbers to hex code by calling the rgbto hex function
    var r_str = rgbtohex(r),
      g_str = rgbtohex(g),
      b_str = rgbtohex(b);
    //concatenate the final string for the output
    var final = '#' + r_str + g_str + b_str;

    //output random color
    return final;
  }
  extractNumbers(string) {
    const numbers = string.match(/\d+/g);
    return numbers ? numbers.map(Number) : [];
  }

  groupObjectsByPermissionName(data) {
    const groupedData = {};

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const subArray = data[key];
        groupedData[key] = {};

        subArray.forEach(obj => {
          const permissionName = obj.permissionName;
          if (groupedData[key][permissionName]) {
            groupedData[key][permissionName].push(obj);
          } else {
            groupedData[key][permissionName] = [obj];
          }
        });
      }
    }

    return groupedData;
  }

  mergeObjectsWithSameKey(data) {
    const mergedData = {};

    data.forEach(obj => {
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          if (Array.isArray(mergedData[key])) {
            mergedData[key] = mergedData[key].concat(obj[key]);
          } else {
            mergedData[key] = obj[key];
          }
        }
      }
    });

    return mergedData;
  }

  async permission(Auth, tabName) {

    let PermittedScreens = ["tabreportConfig", "permission_grant", "user_config"]

    if (PermittedScreens.includes(tabName)) {
      // localStorage.removeItem('permissions');
      var url = this.baseUrl() + "process/permission";
      const Permission = await axios.get(url, Auth);
      console.log(Permission)
      const mergedPermissions = this.mergeObjectsWithSameKey(Permission.data);
      const AllPermissions = this.groupObjectsByPermissionName(mergedPermissions);
      console.log(AllPermissions);
      localStorage.setItem('permissions', JSON.stringify(AllPermissions));

      var Emptyprocesses = []
      Object.entries(AllPermissions).forEach(([k, v]) => {
        if (Object.keys(v).length !== 0) {
          Emptyprocesses.push(k)
        }
      })
      console.log(Emptyprocesses)

      var url = this.baseUrl() + "admin_configuration/process";
      const process = await axios.get(url, Auth);
      const data = process.data
      var processes = []
      for (let process of data) {
        if (Emptyprocesses.includes(process.processName)) {
          processes.push(process)
        }
      }
      localStorage.setItem('process', JSON.stringify(processes));

      window.location.reload()
    }

  }

  checkPermission(module, tabname) {
    var permission = JSON.parse(localStorage.getItem("permissions"));

    if (!permission[module]) {
      return false
    }

    if (tabname) {
      const screenKeyLowerCase = tabname + " view";
      const screenKeyUpperCase = tabname + " View";
      if (permission[module][screenKeyLowerCase] || permission[module][screenKeyUpperCase]) {
        return true
      } else {
        return false
      }
    }
    return true

  }

}

export default new Service;
